import { ProjetosProvider } from "src/providers/ProjetosProvider"
import { ComponenteSolucaoOffGrid, Fileira } from "../../types";
import { oldEstruturas$ } from "src/store/vendas/projetos/offgrid.store";

const projetosProvider = new ProjetosProvider();

interface CalcularEstruturasInput {
  moduloId: number;
  fileiras: Fileira[],
  potencia: number
  regioes: number[]
  inversor: string
  inversores: ComponenteSolucaoOffGrid[]
  controladores: ComponenteSolucaoOffGrid[]
}

export const calcularEstruturas = async (data: CalcularEstruturasInput) => {
  const { moduloId, fileiras, controladores, inversor, inversores, potencia, regioes } = data;

  const estruturaResult = await projetosProvider.calcularEstrutura(moduloId, {
    fileiras: fileiras.map(item => {
      return {
        estrutura_id: Number(item?.tipo_estrutura?.value) || 0,
        estruturas_grupo_id: Number(item?.tipo_estrutura?.estruturas_grupo_id) || 0,
        fileiras_iguais: item.fileiras,
        modulos_sequencia: item.quantidade_modulos,
        posicao: item.posicao_modulo?.value || 'retrato',
      }
    }),
    potencia,
    regiao_id: regioes.map(String),
    inversor: inversor || "",
    segmento: 'off',
    inversores: (inversores || []).length > 0 ? inversores.map(item => ({
      categoria_componentes_id: item.categoria_componentes_id,
      id: item.id,
      quantidade: item.quantidade,
    }) ) : [],
    controladores: (controladores || []).length > 0 ? controladores.map(item => ({
      categoria_componentes_id: item.categoria_componentes_id,
      id: item.id,
      quantidade: item.quantidade,
    }) ) : []
  })
  return estruturaResult.data.map(item => ({
    altura: item.altura,
    categoria_componentes_id: item.categoria_componentes_id,
    componente_id: item.id,
    descricao: item.descricao,
    largura: item.largura,
    nome: item.nome,
    peso: item.peso,
    potencia: 0,
    quantidade: item.quantidade || 0,
    quantidade_original: item.quantidade || 0,
    valor: 0,
    estruturas_grupo_id: item.estruturas_grupo_id,
    valor_unitario: 0,
    exibir_popup_parceiro: item.exibir_popup_parceiro,
  }))
}